import { useQuery } from '@tanstack/react-query';
import { baasSupabase as supabase } from '@/integrations/supabase/baasClient';
import { useBaaSAuth } from '@/contexts/BaaSAuthContext';

export type ApiHealthStatus = 'green' | 'amber' | 'red' | 'unknown';

export interface ApiHealthData {
  status: ApiHealthStatus;
  failure_count: number;
  last_check_at: string | null;
  last_success_at: string | null;
}

export function useBaaSApiHealth() {
  const { baasUser, session } = useBaaSAuth();

  return useQuery({
    queryKey: ['baas-api-health', baasUser?.partnerId],
    enabled: !!baasUser?.partnerId && !!session,
    refetchInterval: 30_000, // poll every 30s
    queryFn: async (): Promise<ApiHealthData> => {
      try {
        const { data, error } = await supabase.functions.invoke('baas-diagnostics', {
          body: {},
          headers: { 'x-custom-path': '/health' },
        });
        if (error) throw error;
        const h = data?.api_health;
        return {
          status: h?.status || 'green',
          failure_count: h?.failure_count || 0,
          last_check_at: h?.last_check_at || null,
          last_success_at: h?.last_success_at || null,
        };
      } catch {
        return { status: 'unknown', failure_count: 0, last_check_at: null, last_success_at: null };
      }
    },
  });
}
